module.exports = __webpack_public_path__ + "2cf41e260990c2d99563b147ada53f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/leagues/espanha.png
// module id = 1045
// module chunks = 0